import styled from 'styled-components'

export const Comment = styled.div`
  width: 100%;
  .index {
    color: #222222;
    float: left;
    margin-top: 2px;
    margin-right: 5px;
  }
  .star {
    float: left;
  }
  .title {
    color: #5F5F5F;
    float: left;
    font-size: 12px;
  }
`



// WEBPACK FOOTER //
// ./src/styled/comment.js